export default "__VITE_ASSET__Dqq8cJfJ__"